/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Step One View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './stepOneView';

export const mapStateToPropsStepOne = mapStateToProps;
export const mapDispatchToPropsStepOne = mapDispatchToProps;

export default connect(mapStateToPropsStepOne, mapDispatchToPropsStepOne)(View);
